export default "__VITE_ASSET__JDXsuvdp__"